import { AfterViewInit, ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild, ViewContainerRef, ChangeDetectionStrategy } from '@angular/core';
import { IToast, ToastType } from '../../models';
import { ToastService } from '../../services/toast/toast.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { TemplatePortal } from '@angular/cdk/portal';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { MatCard, MatCardContent } from '@angular/material/card';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

@Component({
    selector: 'lh-toast',
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss',
    standalone: true,
    imports: [MatCard, MatCardContent, NgClass, MatIcon, MatIconButton], 
    changeDetection: ChangeDetectionStrategy.Eager,
    animations: [
        trigger('fade', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('200ms', style({ opacity: 1 })),
            ]),
            transition(':leave', [
                animate('200ms', style({ opacity: 0 })),
            ]),
        ]),
    ],
})
export class ToastComponent implements OnInit, AfterViewInit {
  @ViewChild('portal') portal!: TemplateRef<unknown>;
  toasts: (IToast & {id: number})[] = []
  idCounter: number = 0
  overlayRef!: OverlayRef;
  
  constructor(private toastService: ToastService, private cdr: ChangeDetectorRef, private overlay: Overlay, private viewContainerRef: ViewContainerRef) {
    this.overlayRef = overlay.create({
      panelClass: "toast-overlay-panel"
    })
  }

  ngOnInit() {
    this.toastService.toast$.subscribe(toast => {
      // A tagged toast replaces any existing toast with the same tag (e.g. "processing" → "done").
      if (toast.tag) {
        this.toasts = this.toasts.filter(t => t.tag !== toast.tag)
      }
      const id = this.idCounter
      this.toasts.push({ id: id, ...toast });
      this.idCounter += 1
      this.cdr.detectChanges()
      // A persistent toast stays until it is closed or replaced; all others auto-dismiss.
      if (!toast.persist) {
        setTimeout(() => this.removeToast(id), toast.duration || 3000);
      }
    });
  }

  ngAfterViewInit(): void {
    this.overlayRef.attach(new TemplatePortal(
      this.portal,
      this.viewContainerRef
    ))
  }

  removeToast(id: number) {
    this.toasts = this.toasts.filter(toast => toast.id !== id);
    this.cdr.detectChanges()
  }

  getTypeClass(type: ToastType): string {
    switch(type) {
      case ToastType.INFO:
        return "info"
      case ToastType.SUCCESS:
        return "success"
      case ToastType.ERROR:
        return "error"
      case ToastType.WARNING:
        return "warn"
      case ToastType.DEFAULT:
        return "default"
      case ToastType.PRIMARY:
        return "primary"
    }
  }

  getTypeIcon(type: ToastType): string {
    switch(type) {
      case ToastType.PRIMARY:
      case ToastType.DEFAULT:
      case ToastType.INFO:
        return "info"
      case ToastType.SUCCESS:
        return "check_circle"
      case ToastType.ERROR:
        return "dangerous"
      case ToastType.WARNING:
        return "warning_amber"
    }
  }

}
